export const ACCESS_TOKEN_NAME = "idp:accessToken";
export const REFRESH_TOKEN_NAME = "idp:refreshToken";
export const GEO_POSITION_KEY = "idp:geoPosition";
export const GEO_LOCATION_KEY = "idp:geoLocation";

export const DateFormat = {
  DEFAULT: "YYYY-MM-DD",
  YEAR: "YYYY",
  SHORT_YEAR: "YYYY",
  USUAL: "DD/MM/YYYY",
  MONTH: "MMMM, YYYY",
  SHORT_MONTH: "MMM, YYYY"
};

export const Languages = [
  { text: "English", id: "en" },
  { text: "Chichewa", id: "ny" },
  { text: "العربية", id: "ar" },
  { text: "kiswahili", id: "sw" },
  { text: "বাংলা", id: "bn" }
];

export const Roles = [
  { label: "Imam", value: "User" },
  { label: "Admin", value: "Admin" }
];

export const LoginNameTypes = [
  { label: "Email", value: "email" },
  { label: "Mobile", value: "mobile" },
  // { label: "Custom", value: "custom" }
];

export const TablePageSize = 10;

export enum Actions {
  CREATE = "CREATE",
  EDIT = "EDIT",
  DELETE = "DELETE"
}

export enum UserStatus {
  ENABLED = "Enabled",
  DISABLED = "Disabled",
}

export enum UserRole {
  Admin = "Admin",
  Imam = "User",
}

export enum UserType {
  Developer = "Developer",
  Company = "Company",
  Customer = "Customer",
}

export const MonthsNumber = [1, 2, 3, 4, 5, 6, 7, 8, 10, 11, 12];
export const ActionColWidth = 120;
export const CheckBoxColWidth = 40;

export enum GenderType {
  MALE = "Male",
  FEMALE = "Female",
  OTHER = "Other",
}
export const Genders = [GenderType.MALE, GenderType.FEMALE, GenderType.OTHER];

export enum MaritalStatus {
  MARRIED = "Married",
  SINGLE = "Signle",
}

export const MaritalStatuses =
  [
    MaritalStatus.MARRIED,
    MaritalStatus.SINGLE
  ];


export enum LOGIN_INACTIVITY {
  LOGIN_SUPPRESS = "LOGIN_SUPPRESS",
  UNKNOWN_TENANT = "UNKNOWN_TENANT",
  LOGIN_DISABLED = "LOGIN_DISABLED",
}

export const SortingHandler = {
  position: 0,
  key: "sort",
  width: 52,
};

// **** enum: Cells; Keys

export enum Cells {
  COMPANY_CELL = "company-link-name",
  SURVEY_CELL = "survey-link-name",
  APPLICATION_TYPE_CELL = "application-type-link-name",
  QUESTIONS_XS_CELL = "question-xs-cell",
  FILE_ICON_CELL = "file-icon-cell",
  LINK_CELL = "link-cell",
  DATE_TIME_CELL = "date-time-cell",
  IS_DISABLED_CELL = "is-disabled-cell",
  LENGTH_COUNT = "length-count",
  NUMBER_HIGHLIGHT = "number-highlight-cell",
  ARR_COUNT_HIGHLIGHT = "arr-count-highlight-cell",
  BADGE_CELL = "badge-cell",
  USER_CELL = "user-link-name",
  USER_AVATAR = "user-avatar",
  USER_AVATAR_NAME = "user-avatar-name"
}

export enum SubmissionStatus {
  PENDING = "Pending",
  ACCEPTED = "Accepted",
  REJECTED = "Rejected",
  NONE = "None"
}

export const NumericDigits: any = {
  "en": ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  "ar": ["٠", "١", "٢", "٣", "٤", "٥", "٦", "٧", "٨", "٩"],
  "bn": ["০", "১", "২", "৩", "৪", "৫", "৬", "৭", "৮", "৯"]
};

export enum VoucherTypes {
  CreditVoucher = 1,
  DebitVoucher = 2,
  JournalVoucher = 3
};

export enum VoucherModules {
  CreditVoucher = "Voucher(Cr)",
  DebitVoucher = "Voucher(Dr)",
  JournalVoucher = "Voucher(Jr)",
  CustomerBill = "CustomerBill(Jr)",
  CustomerBillRecipt = "CustomerBillRecipt(Cr)",
  SupplierBill = "SupplierBill(Jr)",
  SupplierBillPay = "SupplierBillPay(Dr)",
  ClosingVoucher = "ClosingVoucher(Jr)"
};

export enum VoucherCategories {
  GeneralVoucher = "GeneralVoucher",
  CustomerBillVoucher = "CustomerBillVoucher",
  SupplierBillVoucher = "SupplierBillVoucher"
};

export enum SerialStatus {
  BOOKED = "Booked",
  CANCELLED = "Cancelled",
  PRESENT = "Present",
  WAITING = "Waiting",
  SERVING = "Serving",
  SERVED = "Served",
  ABSENT = "Absent"
};

export const SerialStatusTagColor = {
  [SerialStatus.BOOKED]: "default",
  [SerialStatus.CANCELLED]: "warning",
  [SerialStatus.PRESENT]: "default",
  [SerialStatus.WAITING]: "default",
  [SerialStatus.SERVING]: "processing",
  [SerialStatus.SERVED]: "success",
  [SerialStatus.ABSENT]: "error",
  default: "default"
};

export enum WeekDay {
  FRIDAY = "Friday",
  SATURDAY = "Saturday",
  SUNDAY = "Sunday",
  MONDAY = "Monday",
  TUESDAY = "Tuesday",
  WEDNESDAY = "Wednesday",
  THURSDAY = "Thursday"
};
export const WeekDays = [WeekDay.FRIDAY, WeekDay.SATURDAY, WeekDay.SUNDAY, WeekDay.MONDAY, WeekDay.TUESDAY, WeekDay.WEDNESDAY, WeekDay.THURSDAY];